export type SupportedLanguage = "en" | "he";
export type SupportedRegion = "US" | "IL";
export const REGION_DEFAULT: SupportedRegion = "IL";

export const LANGUAGE_TO_REGION_MAP: Record<
  SupportedLanguage,
  SupportedRegion
> = {
  en: "US",
  he: "IL",
} as const;

export const REGION_TO_LANGUAGE_MAP = Object.entries(
  LANGUAGE_TO_REGION_MAP,
).reduce(
  (acc, [language, region]) => {
    acc[region] = language as SupportedLanguage;

    return acc;
  },
  {} as Record<SupportedRegion, SupportedLanguage>,
);

export interface ICustomTranslation {
  path: string;
  en: string;
  he: string;
}
